import React from "react"
import { parkingState } from "../zustand/parkingState"

const Spinner = ({ pleaseWaitText, isActive, isTransparent }) => {
  return (
    <div
      className={`loader js--ajax-loader ${isActive || parkingState.getState().ajaxSpinnerActive ? "is-active" : ""} ${isTransparent || parkingState.getState().ajaxSpinnerTransparent ? "loader--transparent" : ""}`}
    >
      <div className="spinner" />
      {pleaseWaitText ? <p className={"please-wait"}>{pleaseWaitText}</p> : ""}
    </div>
  )
}
export default Spinner
